import React from 'react';
import { createRoot } from 'react-dom/client';
import '@advisor-ui/tokens.css';
import './styles.css';
import App from './App';

const root = createRoot(document.getElementById('root'));
// Do not use React.StrictMode here. The shared Process Advisor runtime still
// contains a few legacy effect-driven integrations (print/export mounts,
// imperative chart hooks) that intentionally run once per mount. StrictMode's
// development double-invocation made Web render duplicate detail/export blocks.
root.render(<App />);
